
//Dependencies
import React, { Component } from 'react';

//material-ui
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import axios from 'axios';
import { valInputText, onPasteText, onPasteNum, valInputNum, valEmailText } from '../../../utils/validate.js'

import { ValidatorForm, TextValidator  } from 'react-material-ui-form-validator';

// persistencia en redux
import {
        setCodigoYLocalidadesDomicilio,
        setLocalidadSelectaDomicilio,
        setValorCampoDomicilio
    } from '../../../actions/actions';

import { store } from '../../../store/configure';
import { connect } from 'react-redux';

import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContentWrapper from './../../Global/SnackbarContentWrapper';

class Domicilio extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        }

        this.form = React.createRef();

        this.handleChange = this.handleChange.bind(this);
        this.submitInvisible = this.submitInvisible.bind(this);
        this.handleKeyPressText = this.handleKeyPressText.bind(this);
        this.handlePasteText = this.handlePasteText.bind(this); 
        this.snackbar = this.snackbar.bind(this);
        this.isDataOk = this.isDataOk.bind(this);
        this.isDataValid = this.isDataValid.bind(this);
    }


    isDataValid(name,value){
        let ok = true
        
        if( (name === "piso" && value.length > 2) ||
            (name === "departamento" && value.length > 2) ){
            ok = false
        }
        return ok
    }

    isDataOk(){
        let { plazoFijoInformacionDomicilio } = this.props;
        
        //campos opcionales
        let pisoIsOk = true
        let deptoIsOk = true

        if(plazoFijoInformacionDomicilio.piso !== ""){
            pisoIsOk = ( !isNaN(plazoFijoInformacionDomicilio.piso) && 
                            plazoFijoInformacionDomicilio.piso.toString().length <= 2 )
        }

        if(plazoFijoInformacionDomicilio.departamento !== ""){
            deptoIsOk = plazoFijoInformacionDomicilio.departamento.toString().length <= 2 
        }

        return pisoIsOk && deptoIsOk && plazoFijoInformacionDomicilio.calle !== "" &&
                plazoFijoInformacionDomicilio.numeroDomicilio !== "" && 
                !isNaN(plazoFijoInformacionDomicilio.numeroDomicilio) && 
                plazoFijoInformacionDomicilio.codigoPostalValido && 
                plazoFijoInformacionDomicilio.codigoPostalValido &&  
                plazoFijoInformacionDomicilio.localidades.length > 0 && 
                !!plazoFijoInformacionDomicilio.localidadSeleccionada === true
    }

    handleKeyPressText = event => {
        if (!valInputText(event)) {
            event.preventDefault();
        }
    }

    handlePasteText = event => {
        onPasteText(event)
    }

    handleKeyPressNum = event => {
        if (!valInputNum(event)) {
            event.preventDefault();
        }
    }

    handlePasteNum = event => {
        onPasteNum(event)
    }

    componentDidMount(){
        ValidatorForm.addValidationRule('isPostalCodeValid', (value) => {
            //https://github.com/jcodagnone/localidades-ar/blob/master/codigo-postal/correo.csv
            return this.props.plazoFijoInformacionDomicilio.localidades.length > 0;
        });
    }

    handleChange(event){
        const name = event.target.name;
        const value = event.target.value

        if( !this.isDataValid(name,value) ){
            return
        }

        switch(name){
            case 'codigo':
            const codigoValido = /^[0-9]{0,4}$/

            if(codigoValido.test(value)){
                this.setState({[name]: value});
                
                if(value.length === 4 ){
                    axios.get(`${localStorage.getItem('url')}/api/plazoFijo/localidad?codigoPostal=${value}`,{withCredentials: true})
                        .then((response)=> {
                            let codigoPostalValido = true
                            let provinciaId = ""
                            if(response.data.length === 0){
                                console.warn("No se hallaron localidades para el cod: " + value + ", reseteando localidades")
                                codigoPostalValido = false
                            }else{
                                provinciaId = response.data[0].provinciaFrontEnd
                            }

                            let data = {
                                localidades:response.data,
                                provinciaId,
                                codigo:value,
                                codigoPostalValido:codigoPostalValido,
                                localidadSeleccionada:""
                            }
                            store.dispatch(
                                setCodigoYLocalidadesDomicilio(data)
                            )
                        })
                        .catch((err)=> {
                           
                        })
                }else{
                    let data = {
                        localidades:[],
                        codigo:value,
                        codigoPostalValido:false,
                        localidadSeleccionada:""
                    }
                    store.dispatch(
                        setCodigoYLocalidadesDomicilio(data)
                    )
                }   
            }
            break;
            default:
                const datoGenericovalido = /^[0-9a-zA-Z\s]{0,20}$/
                if (datoGenericovalido.test(value)) {
                    let data = {
                        fieldName:name,
                        fieldValue:value
                    }
                    store.dispatch(
                        setValorCampoDomicilio(data)
                    )
                }
            break;
        }
    }

    sendDataToReducer(){
        //this.validarFormulario()
    }

    getState(callback) {
        this.setState((prevState) => {
            callback(prevState);
        });
    }

    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ open: false });
    }

    snackbar = () => {
        this.setState({ open: true });
    };

    submitInvisible(){
    }

    forceSubmit(){
        this.form.submit() 

    }

    render() {
        const { classes, plazoFijoInformacionDomicilio, externalSubmitted} = this.props;
        
        let errorLocationSelect = null
        if( externalSubmitted && plazoFijoInformacionDomicilio.codigoPostalValido
            && plazoFijoInformacionDomicilio.localidades.length > 0 
            && plazoFijoInformacionDomicilio.localidadSeleccionada === "" ){

            errorLocationSelect = <FormHelperText style={{color:"red"}}>Debe seleccionar una localidad</FormHelperText>
        }

        return (
            <div className="domicilio">
                <div className="domicilio-container">
                    <Grid container >
                        <Grid item xs={12} md={12}>
                        <ValidatorForm
                                ref={(r) => { this.form = r; }}
                                onSubmit={this.submitInvisible}
                                onError={errors => this.snackbar()}
                            >
                                <Grid container spacing={8} >
                                    <Grid item xs={1} className={classes.svgCenter}>
                                        <svg width="24px" height="21px" viewBox="0 0 24 21">
                                            <g id="MVP-SALIDA-Wireframes" stroke="none" fill="none">
                                                <g id="wizard-3_PlazoFijo" transform="translate(-239.000000, -328.000000)">
                                                    <g id="Group-2" transform="translate(215.000000, 299.000000)">
                                                        <g id="round-home-24px" transform="translate(21.000000, 25.000000)">
                                                            <polygon id="Path" points="0 0 30 0 30 30 0 30"></polygon>
                                                            <path d="M12.5,23.75 L12.5,17.5 L17.5,17.5 L17.5,23.75 C17.5,24.4375 18.0625,25 18.75,25 L22.5,25 C23.1875,25 23.75,24.4375 23.75,23.75 L23.75,15 L25.875,15 C26.45,15 26.725,14.2875 26.2875,13.9125 L15.8375,4.5 C15.3625,4.075 14.6375,4.075 14.1625,4.5 L3.7125,13.9125 C3.2875,14.2875 3.55,15 4.125,15 L6.25,15 L6.25,23.75 C6.25,24.4375 6.8125,25 7.5,25 L11.25,25 C11.9375,25 12.5,24.4375 12.5,23.75 Z" id="Path" fill="#B2B2B2"></path>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </Grid>
                                    <Grid item xs={11} md={7}>
                                        <TextValidator
                                            fullWidth
                                            className="input-container"
                                            onChange={this.handleChange}
                                            value={plazoFijoInformacionDomicilio.calle}
                                            id="calle"
                                            label="Calle"
                                            name="calle"
                                            validators={['required']}
                                            errorMessages={['debe ingresar el nombre de la calle']}
                                        />
                                    </Grid>
                                    <Grid container alignItems="center" justify="flex-end" direction="row" xs={12} md={4}>
                                        <Grid item xs={11} md={12}>
                                            <TextValidator
                                                fullWidth
                                                className="input-container"
                                                onChange={this.handleChange}
                                                value={plazoFijoInformacionDomicilio.numeroDomicilio}
                                                id="departamento"
                                                label="Número"
                                                name="numeroDomicilio"
                                                validators={['required','matchRegexp:^[0-9]{0,8}$','minStringLength:1']}
                                                errorMessages={['debe ingresar la altura','debe ingresar un valor numerico','debe ingresar la altura']}
                                                onKeyPress={this.handleKeyPressNum}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid container spacing={8} >
                                        <Grid item xs={1} className={classes.svgCenter}>
                                            <svg width="24px" height="24px" viewBox="0 0 24 24">
                                                <desc>Created with sketchtool.</desc>
                                                <g id="MVP-SALIDA-Wireframes" stroke="none" fill="none">
                                                    <g id="wizard-3_PlazoFijo" transform="translate(-242.000000, -417.000000)" fill="#B2B2B2">
                                                        <g id="Group-2" transform="translate(215.000000, 299.000000)">
                                                            <g id="round-location_city-24px" transform="translate(24.000000, 115.000000)">
                                                                <path d="M18.75,13.75 L18.75,7.2875 C18.75,6.625 18.4875,5.9875 18.0125,5.525 L15.875,3.3875 C15.3875,2.9 14.6,2.9 14.1125,3.3875 L11.9875,5.5125 C11.5125,5.9875 11.25,6.625 11.25,7.2875 L11.25,8.75 L6.25,8.75 C4.875,8.75 3.75,9.875 3.75,11.25 L3.75,23.75 C3.75,25.125 4.875,26.25 6.25,26.25 L23.75,26.25 C25.125,26.25 26.25,25.125 26.25,23.75 L26.25,16.25 C26.25,14.875 25.125,13.75 23.75,13.75 L18.75,13.75 Z M8.75,23.75 L6.25,23.75 L6.25,21.25 L8.75,21.25 L8.75,23.75 Z M8.75,18.75 L6.25,18.75 L6.25,16.25 L8.75,16.25 L8.75,18.75 Z M8.75,13.75 L6.25,13.75 L6.25,11.25 L8.75,11.25 L8.75,13.75 Z M16.25,23.75 L13.75,23.75 L13.75,21.25 L16.25,21.25 L16.25,23.75 Z M16.25,18.75 L13.75,18.75 L13.75,16.25 L16.25,16.25 L16.25,18.75 Z M16.25,13.75 L13.75,13.75 L13.75,11.25 L16.25,11.25 L16.25,13.75 Z M16.25,8.75 L13.75,8.75 L13.75,6.25 L16.25,6.25 L16.25,8.75 Z M23.75,23.75 L21.25,23.75 L21.25,21.25 L23.75,21.25 L23.75,23.75 Z M23.75,18.75 L21.25,18.75 L21.25,16.25 L23.75,16.25 L23.75,18.75 Z" id="Shape"></path>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                        </Grid>
                                        <Grid item xs={11} md={3} >
                                            <TextValidator
                                                fullWidth
                                                className="input-container"
                                                onChange={this.handleChange}
                                                value={plazoFijoInformacionDomicilio.piso}

                                                id="piso"
                                                label="Piso"
                                                name="piso"
                                                validators={['isNumber', 'maxStringLength:2']}
                                                errorMessages={[ 'Piso inválido', "Maximo 2 digitos"]}
                                                onKeyPress={this.handleKeyPressNum}
                                            />
                                        </Grid>
                                        <Grid item xs={11} md={4}>
                                            <TextValidator
                                                fullWidth
                                                className="input-container"
                                                onChange={this.handleChange}
                                                value={plazoFijoInformacionDomicilio.departamento}
                                                id="departamento"
                                                label="Departamento"
                                                name="departamento"
                                                validators={['maxStringLength:2']}
                                                errorMessages={["Maximo 2 caracteres"]}
                                            />
                                        </Grid>

                                        <Grid item xs={11} md={4} >
                                            <TextValidator
                                                fullWidth
                                                className="input-container"
                                                onChange={this.handleChange}
                                                value={plazoFijoInformacionDomicilio.codigo}
                                                label="Código postal"
                                                name="codigo"
                                                validators={['required','minStringLength:4','isPostalCodeValid']}
                                                errorMessages={['codigo postal es requerido', 'codigo postal invalido' ,'codigo postal invalido']}
                                            />
                                        </Grid>
                                </Grid>

                                <Grid container spacing={8} >  
                                    <Grid container>
                                        <Grid item xs={1} className={classes.svgCenter}>
                                            <svg width="26px" height="26px" viewBox="0 0 26 26">
                                                <desc>Created with sketchtool.</desc>
                                                <g id="MVP-SALIDA-Wireframes" stroke="none" fill="none">
                                                    <g id="wizard-2_PlazoFijo" transform="translate(-239.000000, -300.000000)" fill="#B2B2B2">
                                                        <g id="round-public-24px" transform="translate(239.000000, 300.000000)">
                                                            <path d="M13,0.5 C6.1,0.5 0.5,6.1 0.5,13 C0.5,19.9 6.1,25.5 13,25.5 C19.9,25.5 25.5,19.9 25.5,13 C25.5,6.1 19.9,0.5 13,0.5 Z M11.75,22.9125 C6.8125,22.3 3,18.1 3,13 C3,12.225 3.1,11.4875 3.2625,10.7625 L9.25,16.75 L9.25,18 C9.25,19.375 10.375,20.5 11.75,20.5 L11.75,22.9125 Z M20.375,19.7375 C20.05,18.725 19.125,18 18,18 L16.75,18 L16.75,14.25 C16.75,13.5625 16.1875,13 15.5,13 L8,13 L8,10.5 L10.5,10.5 C11.1875,10.5 11.75,9.9375 11.75,9.25 L11.75,6.75 L14.25,6.75 C15.625,6.75 16.75,5.625 16.75,4.25 L16.75,3.7375 C20.4125,5.225 23,8.8125 23,13 C23,15.6 22,17.9625 20.375,19.7375 Z" id="Shape"></path>
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                        </Grid>          
                                        <Grid item xs={11} md={5} >
                                            <FormControl className="domicilio-form-control">
                                                <InputLabel htmlFor="age-simple">Localidad</InputLabel>
                                                <Select onChange={this.handleChange}
                                                    value={plazoFijoInformacionDomicilio.localidadSeleccionada}
                                                    name="localidadSeleccionada"
                                                    >{Array.isArray(plazoFijoInformacionDomicilio.localidades)?
                                                    plazoFijoInformacionDomicilio.localidades.map((value, key)=> {
                                                        return <MenuItem value={value.id} key={key}>{value.ciuDescripcion}</MenuItem>
                                                    }):null
                                                    }
                                                    <MenuItem value={-1}>Seleccioná</MenuItem>
                                                </Select>
                                                {errorLocationSelect}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </ValidatorForm>
                        </Grid>
                    </Grid>

                    <Snackbar
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        open={this.state.open}
                        autoHideDuration={3000}
                        onClose={this.handleClose}
                    >
                        <SnackbarContentWrapper
                            onClose={this.handleClose}
                            variant="error"
                            message="Revisá los campos en rojo."
                        />
                    </Snackbar>

                </div>
            </div>
        );
    }
}

const styles = {
    root: {
        flexGrow: 1,
    },
    marginGrid: {
        marginLeft: "8% !important"
    },
    svgCenter: {
        display: "block",
        marginTop: "2% !important",
        textAlign: "center"
    }
};

const mapStateToProps = (state) => {
    return ({
      plazoFijoInformacionDomicilio: state.plazoFijoInformacionDomicilio,
      estadoLocal: 'INFORMACION_DOMICILIO'
  });
}

export default connect(mapStateToProps, null, null, { withRef: true }) (withStyles(styles) (Domicilio));



// WEBPACK FOOTER //
// ./src/components/PlazoFijo/datosPersonales/Domicilio.js